<template>
  <div class="select-chips">
    <calendar-chips
      class="select-chips__chips"
      :options="options"
      :filtered-options="filteredTypes"
      :predefined-value="predefinedValue('selectedTypes')"
      @noFilters="noFilters"
      v-model="modelValue.selectedTypes"/>
    <calendar-chips
      class="select-chips__chips"
      v-show="isStatusesVisible"
      title="Status Types:"
      :options="statuses"
      :filtered-options="filteredStatuses"
      :predefined-value="predefinedValue('selectedStatuses')"
      @noFilters="noFilters"
      v-model="modelValue.selectedStatuses"/>
    <calendar-dropdown-multi-select
      class="select-chips__dropdown"
      :options="pageTypes"
      v-show="isTypesVisible"
      :predefined-value="predefinedValue('selectedPageTypes')"
      :filtered-options="filteredPageTypes"
      v-model="modelValue.selectedPageTypes"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import CalendarChips from './CalendarChips'
import CalendarDropdownMultiSelect from './CalendarDropdownMultiSelect'
import { ALLOWED_URL_STATUS_NAMES_CALENDAR } from '@/common/AllowedUrlStatuses'
// eslint-disable-next-line no-unused-vars
import Calendar from './index'

export default {
  name: 'CalendarHeaderNavPanel',
  components: { CalendarDropdownMultiSelect, CalendarChips },
  model: {
    prop: 'modelValue',
    event: 'change'
  },
  props: {
    /**
     * modelValue here is the bridge between {@link Calendar#filters} and {@link CalendarChips} and {@link CalendarDropdownMultiSelect}
     */
    modelValue: {
      type: Object,
      default: () => {
        return {
          selectedTypes: [],
          selectedStatuses: [],
          selectedPageTypes: []
        }
      }
    },
    filtersFromUrl: {
      type: Object,
      default: () => {}
    },
    availablePageTypes: {
      type: Array,
      default: () => []
    },
    filteredStatuses: {
      type: Array,
      default: () => []
    },
    filteredTypes: {
      type: Array,
      default: () => []
    },
    filteredPageTypes: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    modelValue: {
      handler () {
        // disable if filters action not equal to reset
        switch (true) {
          case (this.filteredTypes && this.filteredTypes.filterAction !== 'reset'):
            break
          case (this.filteredStatuses && this.filteredStatuses.filterAction !== 'reset'):
            break
          case (this.filteredPageTypes && this.filteredPageTypes.filterAction !== 'reset'):
            break
          default:
            // next line do skip function if filter from URL have no properties
            if (this.filtersFromUrl && this.filtersFromUrl.selectedTypes && this.filtersFromUrl.selectedTypes.includes('none')) {
              // eslint-disable-next-line no-unused-expressions
              null
            } else if (!this.modelValue.selectedTypes.length) {
              break
            }
            if (this.filtersFromUrl && this.filtersFromUrl.selectedStatuses && this.filtersFromUrl.selectedStatuses.includes('none')) {
              // eslint-disable-next-line no-unused-expressions
              null
            } else if (!this.modelValue.selectedStatuses.length) {
              break
            }
            if (this.filtersFromUrl && this.filtersFromUrl.selectedPageTypes && this.filtersFromUrl.selectedPageTypes.includes('none')) {
              // eslint-disable-next-line no-unused-expressions
              null
            } else if (!this.modelValue.selectedPageTypes.length) {
              break
            }
            this.$emit('clear')
        }
      },
      deep: true,
      immediate: false
    }
  },
  data () {
    return {
      options: [
        { value: 'event', label: 'Events', className: 'calendar__event' },
        { value: 'link', label: 'Links', className: 'calendar__link' },
        { value: 'url', label: 'Publishing', className: 'calendar__url' }
      ],
      predefinedValues: {
        selectedTypes: ['all'],
        selectedStatuses: ['all'],
        selectedPageTypes: ['editorial']
      }
    }
  },
  computed: {
    ...mapState({
      urlStatuses: 'urlStatuses'
    }),
    statuses () {
      const statuses = this.urlStatuses.filter(item =>
        ALLOWED_URL_STATUS_NAMES_CALENDAR.includes(item.label.toLowerCase())
      ).map(item => {
        return {
          label: item.label,
          value: item._id,
          className: `calendar__${item.label.toLowerCase()}`
        }
      })
      // statuses.push({ label: 'All', value: 'all' })
      return statuses
    },
    pageTypes () {
      const pageTypes = this.availablePageTypes
      // add default options
      pageTypes.unshift({ label: 'Editorial', value: 'editorial' })
      pageTypes.push({ label: 'All', value: 'all' })
      return pageTypes
    },
    isStatusesVisible () {
      return this.filteredTypes.types && this.filteredTypes.types.includes('url') && this.modelValue.selectedTypes.includes('url')
    },
    isTypesVisible () {
      const visible = this.modelValue.selectedStatuses.some(item => this.filteredStatuses.types.includes(item))
      return this.isStatusesVisible && visible
    }
  },
  methods: {
    /**
     * method returns filters from URL IF any
     * OR default predefined values
     * @param key
     * @returns array of predefined values
     */
    predefinedValue (key) {
      if (this.filtersFromUrl && this.filtersFromUrl[key] && this.filtersFromUrl[key].length) {
        return this.filtersFromUrl[key]
      } else {
        return this.predefinedValues[key]
      }
    },
    /**
     * if filters from url undefined
     * return process to default behaviour
     */
    noFilters () {
      const modelValueCopy = Object.assign({}, this.modelValue)
      this.$emit('change', modelValueCopy)
      this.$emit('clear')
    }
  }
}
</script>

<style scoped lang="scss">
  .select-chips {
    display: flex;
    align-items: center;

    &__title {
      font-size: 12px;
      color: $rfx-dark-march;
    }

    &__dropdown {
    }

    &__chips {
    }

  }
</style>
